import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CourseService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/courses", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/courses/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ search = "", page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/courses?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/courses/${id}`);
    return response.data;
  },


  delete: async (id) => {
    const response = await apiService.delete(`/courses/${id}`);
    return response.data;
  },
};

export default CourseService;
